import { render, staticRenderFns } from "./StudentServicesHistory.vue?vue&type=template&id=1615fbb1&scoped=true&"
import script from "./StudentServicesHistory.vue?vue&type=script&lang=js&"
export * from "./StudentServicesHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentServicesHistory.vue?vue&type=style&index=0&id=1615fbb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615fbb1",
  null
  
)

export default component.exports